
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
} from '@fortawesome/free-solid-svg-icons'

import Box from '@mui/material/Box'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import TabContext from '@mui/lab/TabContext'

import { useMatomo } from '@jonkoops/matomo-tracker-react'

import React, { Fragment as F, useContext, useEffect, useLayoutEffect, useState } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import Modal from 'react-modal'
import Select from 'react-select'
import { useNavigate } from "react-router-dom"
import { toast } from 'react-toastify'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import PropTypes from 'prop-types'


import {
  appRouter,
  C,
  defaultFintegrationQueryTmpl,
  logg, loggt,
  useApiRouter,
} from "$shared"

import {
  AppCtx,
} from '$src/App'
import {
  QueriesCtx,
} from '$src/components/queries'
import {
  SchedulesCtx,
} from '$src/components/schedules'

import {
  BanksCtx,
  Criteria,
  operator,

  Tab, TabList, TabPanel,
} from '$src/components/banks'

import {
  FintegrationCtx,
  // FintegrationSearch,
} from '$src/components/fintegration'

library.add(
  faBuildingColumns,
  faChevronLeft, faChevronRight, faCircleQuestion, faCreditCard,
  faQuestion,
);




/**
 * FintegrationSearchModal
**/
const FintegrationSearchModal = (props) => {
  // logg(props, 'FintegrationSearchModal')

  /* ctx */

  const apiRouter = useApiRouter()
  const navigate  = useNavigate()
  const { trackPageView, trackEvent } = useMatomo()

  const {
    actionName, setActionName,
    currentUser, setCurrentUser,
    jwtToken,
    loading,    setLoading,
    statesList,
  } = useContext(AppCtx)
  // logg(useContext(AppCtx), 'AppCtx in FintegrationSearch')

  const {
  } = useContext(BanksCtx)
  // logg(useContext(BanksCtx), 'BanksCtx in FintegrationSearch')

  const {
    fintegrationOpts, setFintegrationOpts,
    fintegrationSearchModalOpen, setFintegrationSearchModalOpen,
    fintegrationResultsModalOpen, setFintegrationResultsModalOpen,
    labels,        setLabels,
    query,         setQuery,
    fintegrationResults,       setFintegrationResults,
  } = useContext(FintegrationCtx)
  // logg(useContext(FintegrationCtx), 'FintegrationCtx in FintegrationSearch')
  // loggt(useContext(FintegrationCtx), 'FintegrationCtx in FintegrationSearch')

  /* state */

  const formTabs = [
    { label: 'Core Processor', clauses: [
      { label: 'Core Processor',
        key: 'fintegration.Core_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.coreVendor,
        value: {},
      },
    ], },
    { label: 'Digital', clauses: [
      { label: 'Retail Online Banking',
        key: 'fintegration.Online_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Online_Vendor,
        value: {},
      },
      { label: 'Business Online Banking',
        key: 'fintegration.Business_Online_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Business_Online_Vendor,
        value: {},
      },
      { label: 'Retail Mobile Banking',
        key: 'fintegration.Mobile_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.mobileVendor,
        value: {},
      },

    ] },
    { label: 'NAO & LOS', clauses: [
      { label: 'Online New Account Opening',
        key: 'fintegration.Online_New_Account_Opening',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Online_New_Account_Opening,
        value: {},
      },
      { label: 'POS Online Auto LOS',
        key: 'fintegration.Online_Auto_Loan_Origination_System',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Online_Auto_Loan_Origination_System,
        value: {},
      },
      { label: 'POS Online Mortgage LOS',
        key: 'fintegration.Online_Mortgage_Loan_Origination_System',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Online_Mortgage_Loan_Origination_System,
        value: {},
      },
      { label: 'Commercial LOS',
        key: 'fintegration.Commercial_LOS',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Commercial_LOS,
        value: {},
      }, // wired on 2026-01

    ] },
    { label: 'Debit', clauses: [
      { label: 'Debit Processor',
        key: 'fintegration.Debit_Processor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.debitProcessor,
        value: {},
      },
      { label: 'Debit Card Type',
        key: 'fintegration.Debit_Card_Type',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.debitCardType,
        value: {},
      },

    ] },
    { label: 'Credit', clauses: [
      { label: 'Credit Processor',
        key: 'fintegration.Credit_Processor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.creditProcessor,
        value: {},
      },
      { label: 'Credit Card Issuer',
        key: 'fintegration.Credit_Card_Issuer',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.creditCardIssuer,
        value: {},
      },
      { label: 'Credit Card Network',
        key: 'fintegration.Credit_Card_Type',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.creditCardType,
        value: {},
      },

    ] },
    { label: 'Additional Payments', clauses: [
      { label: 'Bill Pay',
        key: 'fintegration.Bill_Pay_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.billPayVendor,
        value: {},
      },
      { label: 'Merchant Services',
        key: 'fintegration.Merchant_Services_Processor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.merchantServicesProcessor,
        value: {},
      },
      { label: 'P2P',
        key: 'fintegration.P2P_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.P2P_Vendor,
        value: {},
      },
      { label: 'Checks',
        key: 'fintegration.Check_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Check_Vendor,
        value: {},
      }, // wired on 2026-01
      { label: 'ATM Network',
        key: 'fintegration.ATM_Network',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.ATM_Network,
        value: {},
      }, // wired on 2026-01

    ] },
    { label: 'Other Categories', clauses: [
      { label: 'Web Live Chat',
        key: 'fintegration.Web_Live_Chat_Vendor',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Web_Live_Chat_Vendor,
        value: {},
      }, // wired on 2026-01
      { label: 'Content Management System (CMS)',
        key: 'fintegration.Content_Management_System',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Content_Management_System,
        value: {},
      }, // wired on 2026-01

      { label: 'Rewards',
        key: 'fintegration.Rewards',
        operator: C.op.multiselect_checkboxes,
        options: fintegrationOpts.Rewards,
        value: {},
      },
    ] },
    { label: 'Total Assets', clauses: [
      { className: 'total-assets',
        key: 'View_Bank_Total_Assets.Total_Assets',
        label: 'Total Assets',
        operator: C.op.between,
        value: [ null, null ],
      },
    ] },
  ];

  const [ activeTab, setActiveTab ] = useState(formTabs[0].label)

  /* effects */

  /* get fintegrationOpts */
  useEffect(() => {
    if (!jwtToken) { return; }
    if (fintegrationOpts.coreVendor.length) { return; }

    fetch(apiRouter.fintegrationOptsPath()).then(r => r.json()).then(input => {
      logg(input, 'got fintegrationOpts')
      setFintegrationOpts(input)
    })
  }, [ jwtToken, fintegrationOpts ])

  useEffect(() => {
    trackPageView()
    trackEvent({ category: 'FintegrationSearchModal', action: 'show' })
  }, [ fintegrationSearchModalOpen ])

  /* methods */

  const handleClearQuery = () => {
    // logg(null, 'Fintegration handleClearQuery')
    setQuery(JSON.parse(JSON.stringify(defaultFintegrationQueryTmpl)))
  }

  /*
   * action is unused here? It's always run a query, never save a query.
  **/
  const handleRun = (action) => {
    setLoading(true)
    const body = { query, jwt_token: localStorage.getItem('jwt_token') }
    const url = apiRouter.fintegrationRunPath({})
    fetch(url, { method: 'POST',
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(body),
    }).then(r => {
      if (!r.ok) {
        throw("No results returned. Did you select anything?")
      }
      return r.json()
    }).then((outcome) => { // { labels, rows }
      setFintegrationResults(outcome.rows)
      setLabels(outcome.labels)
      setFintegrationResultsModalOpen(true)
      // setFintegrationSearchModalOpen(false)
    }).catch((err) => {
      logg(err, 'Cannot handleRun')
      toast(err)
    }).finally(() => {
      setLoading(false)
    })
  }

  const setClause = (k, v) => {
    // logg([k, v], 'setClause')
    const clauses = { ...query.clauses }
    clauses[k] = v
    setQuery({ ...query, clauses })
  }

  const unauthorized = currentUser.roles &&
      currentUser.roles.indexOf(C.roles.INTERNAL)     === -1 &&
      currentUser.roles.indexOf(C.roles.FINTEGRATION) === -1

  return <Modal
    ariaHideApp={false}
    className="FintegrationSearchModal BaseModal"
    isOpen={fintegrationSearchModalOpen}
    onRequestClose={ () => setFintegrationSearchModalOpen(false) }
    overlayClassName="ModalOverlay"
  >
    <div className='header'>
      <h5>Fintegration Search</h5>
      <div className='close' onClick={() => setFintegrationSearchModalOpen(false)} >&times;</div>
    </div>
    <div className='padded'>
      <div className='FintegrationSearch' >
        { unauthorized && <F>
          <p>Sorry, you don't have authorizaton to view this data.</p>
          <p>Please contact the <a href="mailto:info@fedfis.com">Sales</a> team to upgrade your account.</p>
        </F> ||
        <form data-testid="formId" onSubmit={(ev) => {
          ev.preventDefault()
          handleRun(C.queries_actions.run)
        } } >
          <div className={`a-tab tab-query`}>

            <TabContext value={activeTab} >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList
                variant="scrollable"
                scrollButtons="auto"
                onChange={(_, val) => setActiveTab(val)} >
                  { formTabs.map((clause, idx) =>
                    <Tab key={clause.label} label={clause.label} value={clause.label} />
                  ) }
                </TabList>
              </Box>
              { formTabs.map((formTab, idx) => <TabPanel className='FintegrationTabPanel'
                                                         key={formTab.label}
                                                         value={formTab.label} >{ /* The selected tab */ }
                { formTab.clauses.map((clause, idx) =>
                  <div key={clause.label}
                       className={`clause ${clause.className}`}
                  >
                    <label >{ clause.label }</label>
                    { operator({
                      clause, setClause,
                      query,  setQuery,
                    }) }
                  </div>
                ) }
              </TabPanel> )}
            </TabContext>
            <div className="actions mt-2 p-0">
              <div className='left'>
                <input type="reset" className='Btn' onClick={handleClearQuery}        value='clear' ></input>
              </div>
              <div className='right'>
                {/* <input type='button' className='Btn btn-primary' onClick={handleSave}              value='Save'></input> */}
                &nbsp; &nbsp;&nbsp;
                <input className='Btn btn-primary' type='submit' value='Run' ></input>
              </div>
            </div>

          </div>
        </form> }
      </div>{/* .FintegrationSearch */}
    </div>
  </Modal>
}
export default FintegrationSearchModal

